import React from 'react'
import { sanityImageUrl, urlWithSearchParamsHandler } from '../../../utils/helpers'
import { ProtocolPrice, isTestosteroneProduct } from '../../../utils/experiment_data'
import { useExperimentData } from '../../../context/ExperimentContext'
import { Link } from 'gatsby'
import styles from './style.module.sass'

export default ({ protocol }) => {
  const { ampTestosteronePriceVariant, ampBloodflowPriceVariant, ampFirstInstallmentDiscountVariant } = useExperimentData()

  return (
    <div className={styles.item}>
      <div className={styles.itemTop}>
        <Link to={protocol.learnMoreButtonUrl} className={styles.imageBox}>
          {protocol.tag && <span className={styles.tag}>{protocol.tag}</span>}
          <img src={sanityImageUrl(protocol.image)} className={styles.image} alt={protocol.image?.caption} />
        </Link>

        <div className={styles.itemWrap}>
          <p className={styles.name}>{protocol.title}</p>
          <div className={styles.benefits}>
            {protocol.benefits &&
              protocol.benefits.map((item, index) => (
                <p className={styles.benefitsItem} key={index}>
                  {item}
                </p>
              ))}
          </div>
        </div>
      </div>

      <div className={styles.itemBottom}>
        <div className={styles.price}>
          {(ampFirstInstallmentDiscountVariant === 'testosterone_first_installment_discount_variation_1' && isTestosteroneProduct(protocol.title)) ? (
            <div className={styles.discount}>
              <span>First month free</span>
              <p>{protocol.price}/mo after</p>
            </div>
          ) : (
            <ProtocolPrice
              title={protocol.title}
              price={protocol.price}
              testosteroneVariant={ampTestosteronePriceVariant} 
              bfVariant={ampBloodflowPriceVariant}
              htmlTemplate="Starting at <span>_price_</span>/mo"
              integerOnly={true}
              htmlDefault={true}
            />
          )}        
        </div>
        <div className={styles.buttons}>
          <Link className={styles.buttonsMore} to={protocol.learnMoreButtonUrl}>
            {protocol.learnMoreButtonText}
          </Link>
          <a
            href={protocol.getStartedButtonUrl}
            onClick={urlWithSearchParamsHandler}
            className={styles.buttonsStarted}
          >Start Treatment</a>
        </div>
        <p className={styles.available}>{protocol.available}</p>
      </div>
    </div>
  )
}
